module.exports = __webpack_public_path__ + "img/vertical_7_7_9005.25016116.png";